export interface UserLimitsResponseModelV3 {
  workspace_create_workspace?: boolean;
  /** @format int32 */
  max_pinned_conversations?: number;
  teams?: FeatureState;
  external_conversations?: FeatureState;
  video_calls?: FeatureState;
  export_cases?: FeatureState;
  voice_messages?: {
    maxLengthSeconds?: number;
    promptThrottleIntervalMinutes?: number;
    /** Only show prompt when this value is Upgradable */
    featureState?: FeatureState;
  };
  scribe?: {
    featureState?: FeatureState;
    maxSessionLengthMinutes?: number;
    maxSessions?: number;
  };
  conversation_creation_limit?: {
    chatsLimit?: number;
    groupsLimit?: number;
    patientCasesLimit?: number;
    teamChatsLimit?: number;
    externalConversationsLimit?: number;
  };
  message_history_limit?: {
    maxDays?: number;
  }
  /** Missing on older backends, which means enabled */
  identity_verification?: FeatureState;
}

export interface UserUsageResponseModel {
  conversationUsage?: ConversationUsage;
}

export interface ConversationUsage {
  chatsCreated?: number;
  groupsCreated?: number;
  patientCasesCreated?: number;
  teamChatsCreated?: number;
  externalConversationsCreated?: number;
}

export enum FeatureState {
  Upgradeable = "Upgradeable",
  Disabled = "Disabled",
  Unauthorized = "Unauthorized",
  Enabled = "Enabled",
  Invisible = "Invisible",
}

export interface AnalyticsLogModel {
  eventType: string;
  /** Format is iso8601 */
  timestamp: string;
  sessionId: string;
  userId?: string;
  referrer?: string;
  limitType?: string;
  currentCount?: number;
  maxAllowed?: number;
  ctaType?: string;
  banner?: Banner;
  bannerAction?: BannerAction;
  interactionId?: string;
  /** Corti template key or document templateRef */
  templateId?: string;
  sectionKey?: string;
  isResuming?: boolean;
  /** Lifetime number of the G2 review prompt being shown */
  promptCount?: number;
  /** G2 review prompt rating: "positive" or "negative" */
  rating?: string;
}

export interface Banner {
  id: string;

  /** The content that should be displayed in the banner. This is markdown. */
  content: string;

  /** The list of actions this banner should perform when actioned (e.g. tapped). */
  actions: BannerAction[];

  /** Determines in what order this banner should be shown when multiple banners exist. Lower values are shown earlier. */
  order: number;

  category: 1 | 2;

  isDismissible: boolean;

  /** Client-only: how long a dismissal should be remembered. Defaults to persisting in local storage. Not sent by the server. */
  dismissPersistence?: "session" | "none";
}

export interface BannerAction {
  /** Action display text. */
  displayText: string;

  /** The type of action (e.g. Link means the banner opens a URL). */
  type: BannerActionType;

  /** Data relevant to the action type. For a "link" action, this is a URL. */
  value: string;

  /** Used to determine the order of this action within its banner. Lower values are positioned earlier. */
  order: number;
}

export enum BannerActionType {
  /** Opens a URL in the user’s web browser. */
  Link = "Link",

  /** Client-only: reloads the page. Never sent by the server. */
  Reload = "Reload",
}
